import React from 'react';
import { StatusChip } from '../../elements';

const SQM_PER_PIG_THRESHOLD = 0.8;

interface SquareMetersPerPigChipProps {
  areaInM: number | undefined;
  animalsCount: number | undefined;
}

const SquareMetersPerPigChip: React.FC<SquareMetersPerPigChipProps> = ({ areaInM, animalsCount }) => {
  const area = areaInM ?? 0;
  const count = animalsCount ?? 0;

  if (count <= 0 || area <= 0) {
    return <span>-</span>;
  }

  const sqmPerPig = area / count;
  const value = sqmPerPig.toFixed(2);
  const color = sqmPerPig < SQM_PER_PIG_THRESHOLD ? 'orange' : 'green';

  return <StatusChip label={value} color={color} />;
};

export default SquareMetersPerPigChip;
